import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useParseTranslation = (ns) => {
  const { i18n } = useTranslation();

  return useCallback((item, field) => {
    const text = item?.[field] || item;
    const key = ns ? `${ns}:${text}` : text;
    return (i18n.exists(key) ? i18n.t(key) : text);
  }, [i18n, ns]);
};
